import { render } from "./ClassForm.vue?vue&type=template&id=0e3425a0&scoped=true"
import script from "./ClassForm.vue?vue&type=script&lang=js"
export * from "./ClassForm.vue?vue&type=script&lang=js"

import "./ClassForm.vue?vue&type=style&index=0&id=0e3425a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3425a0"]])

export default __exports__